/* YAZA additions: use the theme's existing variant pricing and product forms. */
(() => {
  if (customElements.get('yaza-embroidery')) return;
  class YazaEmbroidery extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-details') || this.parentElement;
      this.sync = () => {
        const options = this.scope.querySelectorAll('variant-picker input:checked, variant-picker select');
        let selected;
        options.forEach((input) => {
          const name = (input.dataset.optionName || input.name || '').toLowerCase();
          if (name.includes('embroidery') || name.includes('broderie')) selected = input.value;
        });
        const fieldset = this.querySelector('fieldset');
        if (!fieldset || selected === undefined) return;
        const enabled = /^(with embroidery|avec broderie)/i.test(selected.trim());
        fieldset.hidden = !enabled;
        fieldset.disabled = !enabled;
      };
      this.scope.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      const picker = this.scope.querySelector('variant-picker');
      if (picker) this.observer.observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
      this.sync();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.sync);
      this.observer?.disconnect();
    }
  }
  customElements.define('yaza-embroidery', YazaEmbroidery);

  // A few existing policy pages contain literal Markdown inside HTML paragraphs.
  // Convert only those text nodes; preserve all links, headings and policy wording.
  const policy = document.querySelector('.shopify-policy__body');
  if (policy) {
    const walker = document.createTreeWalker(policy, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (!node.textContent.includes('**')) return;
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\*\*[^*]+\*\*)/g).forEach((part) => {
        if (part.startsWith('**') && part.endsWith('**')) {
          const strong = document.createElement('strong');
          strong.textContent = part.slice(2, -2);
          fragment.append(strong);
        } else fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }
})();
